/*
 * Zühre Ana - cart drawer and cart page (sections/cart_widget.liquid, sections/cart-template.liquid)
 * Vanilla JS (ES5), no dependencies, loaded with defer. Texts, routes and the free-shipping amount come
 * from the JSON printed by snippets/za-cart-upsell.liquid (part: 'config').
 *
 * 1. Free-shipping progress [data-za-ship]: "Mai adaugă X lei și ai transport gratuit!" /
 *    "Felicitări! Ai transport gratuit." - repainted after every cart change.
 * 2. Suggestions [data-za-upsell]: /recommendations/products.json for the product added last, without
 *    products already in the cart or sold out; while the cart is under the free-shipping amount the
 *    products that take it over the amount come first. One tap on "Adaugă" posts to /cart/add.js.
 *    An empty cart (and a cart without recommendations) shows the best sellers printed by Liquid.
 * 3. Pack upgrade [data-za-nudge] under a single-unit line: "Ia Set de 2 și economisești X lei".
 *    One tap adds the pack, then removes the single unit; the other lines are not touched.
 *
 * How it talks to the theme (assets/swatch.min.js):
 * - every cart request asks Shopify for the rendered section "cart_js" (sections/cart_js.liquid), the
 *   same fragment the theme uses, and hands it to geckoShopify.onCartUpdate(), which updates the cart
 *   count, the empty state and the theme's own widgets. The theme only repaints when the number of
 *   items changed, so the lines, the discounts and the total are also written here from that fragment.
 * - cart changes made by the theme (add to cart, +/-, "Șterge") are noticed through the DOM it rewrites
 *   (.js_cat_items, .js_cat_ttprice), its jQuery events (CartUpdateSuccess, CartChangeSuccess) and the
 *   "cart:refresh" document event; the drawer opening is noticed through the "act_opened" class.
 *
 * Without this file (or without fetch) the cart still works: the progress bar keeps the state printed
 * by Liquid, the best-seller buttons are plain links to the product pages, the offers stay hidden.
 */
(function () {
  'use strict';

  var win = window;
  var doc = document;

  if (win.zaCart && typeof win.zaCart.init === 'function') {
    // The section was rendered again (theme editor): read the settings again and repaint.
    win.zaCart.init();
    return;
  }
  if (!win.fetch || !win.Promise || !win.JSON || !doc.querySelector || !win.MutationObserver) {
    return;
  }

  var SECTION = 'cart_js';
  var SPLIT_OUTER = '[split_t4nt0]';
  var SPLIT_INNER = '[split_t4nt]';
  var TIMEOUT = 20000;       // ms before a cart request is given up
  var MAX_CARDS = 4;
  var RECS_LIMIT = 8;

  var cfg = null;
  var T = {};
  var state = {
    cart: null,        // { item_count, total_price, items: [{ product_id, variant_id, key, quantity }] }
    baseId: null,      // product the suggestions are built for
    seen: {},          // product ids in the cart at the last look
    ownAdds: {},       // product ids added from the suggestions row
    recs: {},          // product id -> list of products, or 'pending'
    busy: false,       // one cart request of ours at a time
    changed: false,    // the cart changed since the page was loaded
    anchor: null,      // element that must not move while the cart is repainted
    hold: 0,           // the suggestions are not rebuilt before this time (the tapped card shows "Adăugat")
    seq: 0
  };
  var observers = [];
  var syncTimer = null;
  var holdTimer = null;
  var msgTimer = null;
  var listening = false;

  /* ------------------------------------------------------------------
     Small helpers
     ------------------------------------------------------------------ */

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function one(selector, scope) {
    return (scope || doc).querySelector(selector);
  }

  function all(selector, scope) {
    return toArray((scope || doc).querySelectorAll(selector));
  }

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      var matches = el.matches || el.webkitMatchesSelector || el.msMatchesSelector;
      if (matches && matches.call(el, selector)) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  function isArray(value) {
    return Object.prototype.toString.call(value) === '[object Array]';
  }

  function int(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  // Shopify's .js endpoints send prices as integers (bani); a decimal string is converted.
  function cents(value) {
    if (typeof value === 'number') {
      return Math.round(value);
    }
    if (typeof value === 'string' && value !== '') {
      return value.indexOf('.') === -1 ? int(value) : Math.round(parseFloat(value) * 100);
    }
    return 0;
  }

  function fill(text, key, value) {
    return String(text == null ? '' : text).split('[' + key + ']').join(value);
  }

  function now() {
    return new Date().getTime();
  }

  // Spaces become no-break spaces.
  function nowrap(text) {
    return String(text).replace(/ /g, '\u00a0');
  }

  /* Same output as the Liquid "money" filter, e.g. 123450 -> "1.234,50 lei". */
  function money(amount) {
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var format = cfg && typeof cfg.moneyFormat === 'string' && pattern.test(cfg.moneyFormat) ? cfg.moneyFormat : '{{amount_with_comma_separator}} lei';

    function num(precision, thousands, decimal) {
      var parts = (Math.abs(amount) / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return (amount < 0 ? '-' : '') + (parts[1] ? whole + decimal + parts[1] : whole);
    }

    var value;
    switch (format.match(pattern)[1]) {
      case 'amount_no_decimals':
        value = num(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = num(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = num(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = num(2, '\'', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = num(0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = num(2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = num(2, ' ', '.');
        break;
      default:
        value = num(2, ',', '.');
    }
    return format.replace(pattern, value);
  }

  /* Units in a "Pachet" value: "1", "1 bucată", "1 cutie", "Set de 1" -> 1, "Set de 2" -> 2,
     "Set de 3+1" -> 4. Anything that is not a small number -> 0 (no offer). */
  function units(raw) {
    var text = String(raw == null ? '' : raw).toLowerCase();
    var plus = text.match(/(\d+)\s*\+\s*(\d+)/);
    var first = text.match(/\d+/);
    var count = plus ? int(plus[1]) + int(plus[2]) : (first ? int(first[0]) : 0);
    return count > 0 && count <= 12 ? count : 0;
  }

  /* Card titles are narrow: "Zühre Ana Pastă de Propolis" -> "Pastă de Propolis". */
  function shortName(title) {
    var name = String(title == null ? '' : title);
    var prefix = cfg && typeof cfg.strip === 'string' ? cfg.strip : '';
    if (prefix && name.toLowerCase().indexOf(prefix.toLowerCase()) === 0) {
      var rest = name.slice(prefix.length).replace(/^[\s\-–|:]+/, '');
      if (rest) {
        return rest;
      }
    }
    return name;
  }

  function sized(src, width) {
    var url = String(src || '');
    if (!url) {
      return '';
    }
    url = url.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function readConfig() {
    var el = one('[data-za-cart-config]');
    if (!el) {
      return null;
    }
    try {
      var data = JSON.parse(el.textContent || el.innerHTML || '');
      return data && typeof data === 'object' ? data : null;
    } catch (error) {
      return null;
    }
  }

  function isPage() {
    return cfg.ctx === 'page';
  }

  function drawerOpen() {
    var canvas = doc.getElementById('nt_cart_canvas');
    return !!canvas && canvas.classList.contains('act_opened');
  }

  /* ------------------------------------------------------------------
     Requests
     ------------------------------------------------------------------ */

  function request(method, url, body) {
    var options = {
      method: method,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    };
    var timer = null;

    if (body) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    if (win.AbortController) {
      var controller = new win.AbortController();
      options.signal = controller.signal;
      timer = win.setTimeout(function () {
        controller.abort();
      }, TIMEOUT);
    }

    function done() {
      if (timer) {
        win.clearTimeout(timer);
      }
    }

    return win.fetch(url, options).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try {
          data = JSON.parse(text);
        } catch (error) {
          data = null;
        }
        done();
        return { ok: response.ok && data !== null && typeof data === 'object', status: response.status, data: data || {} };
      });
    }, function (error) {
      done();
      throw error;
    });
  }

  /* Shopify explains stock problems in the shop language ("description"); anything else gets our sentence. */
  function shopError(result) {
    var data = result && result.data ? result.data : {};
    var text = typeof data.description === 'string' ? data.description : '';
    var error = new Error(text);
    error.zaText = result && result.status === 422 ? text : '';
    return error;
  }

  function errorText(error) {
    return error && error.zaText ? error.zaText : T.error;
  }

  /* ------------------------------------------------------------------
     Messages
     ------------------------------------------------------------------ */

  // Screen readers only (visually hidden live region).
  function say(text) {
    var live = one('[data-za-cart-live]');
    if (!live) {
      return;
    }
    live.textContent = '';
    win.setTimeout(function () {
      live.textContent = text;
    }, 60);
  }

  // Visible error line under the progress bar.
  function showMessage(text) {
    var box = one('[data-za-cart-msg]');
    if (msgTimer) {
      win.clearTimeout(msgTimer);
      msgTimer = null;
    }
    if (!box) {
      return;
    }
    box.textContent = text || '';
    box.hidden = !text;
    if (!text) {
      return;
    }
    if (isPage() && box.scrollIntoView) {
      try {
        box.scrollIntoView({ block: 'center' });
      } catch (error) {
        box.scrollIntoView();
      }
    }
    msgTimer = win.setTimeout(function () {
      box.hidden = true;
      box.textContent = '';
    }, 12000);
  }

  function showUpsellError(box, text) {
    var el = box ? one('[data-za-upsell-msg]', box) : null;
    if (!el) {
      if (text) {
        showMessage(text);
      }
      return;
    }
    el.textContent = text || '';
    el.hidden = !text;
  }

  /* ------------------------------------------------------------------
     Theme refresh
     ------------------------------------------------------------------ */

  /* sections/cart_js.liquid: [split_t4nt0] count | shipping | lines | discounts | total | ... [split_t4nt0] */
  function parseSection(html) {
    if (typeof html !== 'string') {
      return null;
    }
    var outer = html.split(SPLIT_OUTER);
    if (outer.length < 2) {
      return null;
    }
    var parts = outer[1].split(SPLIT_INNER);
    if (parts.length < 5) {
      return null;
    }
    return { count: parts[0].replace(/\s+/g, ''), items: parts[2], discounts: parts[3], total: parts[4] };
  }

  function dropRecords() {
    observers.forEach(function (observer) {
      observer.takeRecords();
    });
  }

  function setDisplay(selector, visible) {
    all(selector).forEach(function (el) {
      el.style.display = visible ? 'block' : 'none';
    });
  }

  /* Only used while the theme script is not there yet (it does the same in onCartUpdate). */
  function toggleEmpty(empty) {
    if (isPage()) {
      setDisplay('.nt_js_cart', !empty);
      setDisplay('.empty_cart_page', empty);
    } else {
      setDisplay('.nt_js_cart .js_cart_footer, .nt_js_cart .js_cart_tool, .js_cat_items', !empty);
      setDisplay('.nt_js_cart .empty', empty);
    }
  }

  function paintSection(parts, themeRan) {
    all('.js_cat_items').forEach(function (el) {
      el.innerHTML = parts.items;
    });
    all('.js_cat_dics').forEach(function (el) {
      el.innerHTML = parts.discounts;
    });
    all('.js_cat_ttprice').forEach(function (el) {
      el.innerHTML = parts.total;
    });
    if (!themeRan) {
      all('.jsccount').forEach(function (el) {
        el.innerHTML = parts.count;
      });
      toggleEmpty(int(parts.count) === 0);
    }
    dropRecords();
    paintLines();
  }

  function themeRefresh(html) {
    var parts = parseSection(html);
    var theme = win.geckoShopify;
    var ran = false;

    if (!parts) {
      return false;
    }
    if (theme && typeof theme.onCartUpdate === 'function') {
      try {
        // (open the drawer afterwards: no, repaint the lines: no - done below for every case)
        theme.onCartUpdate(0, 0, html);
        ran = true;
      } catch (error) {
        ran = false;
      }
    }
    paintSection(parts, ran);
    return true;
  }

  /* The cart fragment did not come with the answer: fetch it like the theme does. */
  function fetchSection() {
    var url = win.location.pathname + '?section_id=' + SECTION;
    return win.fetch(url, { credentials: 'same-origin', headers: { 'cache-control': 'no-cache' } })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        return themeRefresh(html);
      }, function () {
        return false;
      });
  }

  function refreshFrom(data) {
    var html = data && data.sections ? data.sections[SECTION] : null;
    if (themeRefresh(html)) {
      return win.Promise.resolve(true);
    }
    return fetchSection();
  }

  /* ------------------------------------------------------------------
     Cart state
     ------------------------------------------------------------------ */

  function normalize(cart) {
    var items = [];
    toArray(cart && cart.items).forEach(function (item) {
      if (!item) {
        return;
      }
      items.push({
        product_id: String(item.product_id),
        variant_id: String(item.variant_id),
        key: String(item.key),
        quantity: int(item.quantity)
      });
    });
    return { item_count: int(cart.item_count), total_price: cents(cart.total_price), items: items };
  }

  function idsInCart() {
    var ids = {};
    if (state.cart) {
      state.cart.items.forEach(function (item) {
        ids[item.product_id] = true;
      });
    }
    return ids;
  }

  /* Suggestions follow the product added last (Shopify lists the newest line first). Products added
     from the suggestions row itself do not move the row, so it stays put while the customer picks. */
  function chooseBase() {
    var items = state.cart.items;
    var ids = idsInCart();
    var first = null;
    var i;

    for (i = 0; i < items.length; i++) {
      if (!state.ownAdds[items[i].product_id]) {
        first = items[i].product_id;
        break;
      }
    }
    if (first === null && items.length) {
      first = items[0].product_id;
    }
    if (state.baseId === null || !ids[state.baseId] || (first !== null && !state.seen[first])) {
      state.baseId = first;
    }
    state.seen = ids;
  }

  function setCart(cart) {
    state.cart = normalize(cart);
    chooseBase();
    paint();
  }

  function sync(cart) {
    if (cart && typeof cart.item_count === 'number' && isArray(cart.items)) {
      state.seq += 1;
      setCart(cart);
      return win.Promise.resolve(state.cart);
    }
    var seq = ++state.seq;
    return request('GET', cfg.cartUrl + '.js').then(function (result) {
      if (seq === state.seq && result.ok && isArray(result.data.items)) {
        setCart(result.data);
      }
      return state.cart;
    }, function () {
      return state.cart;
    });
  }

  function scheduleSync() {
    if (syncTimer) {
      win.clearTimeout(syncTimer);
    }
    syncTimer = win.setTimeout(function () {
      syncTimer = null;
      if (state.busy) {
        return; // our own request repaints when it is done
      }
      state.changed = true;
      sync();
    }, 150);
  }

  /* ------------------------------------------------------------------
     Keeping the view still
     ------------------------------------------------------------------ */

  function scrollerOf(el) {
    var node = el ? el.parentNode : null;
    while (node && node.nodeType === 1 && node !== doc.body) {
      var style = win.getComputedStyle(node);
      if ((style.overflowY === 'auto' || style.overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  /* Runs fn (which changes the height of things above el) and puts el back where it was on screen. */
  function keepPlace(el, fn) {
    if (!el || !doc.documentElement.contains(el) || !el.getBoundingClientRect) {
      fn();
      return;
    }
    var before = el.getBoundingClientRect().top;
    fn();
    if (!doc.documentElement.contains(el)) {
      return;
    }
    var delta = el.getBoundingClientRect().top - before;
    if (Math.abs(delta) < 1) {
      return;
    }
    var scroller = scrollerOf(el);
    if (scroller) {
      scroller.scrollTop += delta;
    } else if (isPage()) {
      if ('scrollBehavior' in doc.documentElement.style) {
        win.scrollBy({ top: delta, left: 0, behavior: 'instant' });
      } else {
        win.scrollBy(0, delta);
      }
    }
  }

  /* Brings the line of a variant into view and marks it for a moment. */
  function reveal(variantId, scroll) {
    var line = one('.js_cat_items .cart_item_' + variantId);
    if (!line) {
      return;
    }
    line.classList.add('za-ci--new');
    win.setTimeout(function () {
      line.classList.remove('za-ci--new');
    }, 1800);
    if (!scroll) {
      return;
    }
    var scroller = scrollerOf(line);
    if (scroller) {
      scroller.scrollTop = Math.max(0, scroller.scrollTop + line.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 8);
    } else if (isPage() && line.scrollIntoView) {
      var rect = line.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > (win.innerHeight || doc.documentElement.clientHeight)) {
        try {
          line.scrollIntoView({ block: 'center' });
        } catch (error) {
          line.scrollIntoView();
        }
      }
    }
  }

  /* ------------------------------------------------------------------
     1. Free-shipping progress
     ------------------------------------------------------------------ */

  function paintShip() {
    var cart = state.cart;
    var min = int(cfg.shipMin);
    if (!cart || min <= 0) {
      return;
    }
    var left = min - cart.total_price;
    var mode = cart.item_count === 0 ? 'empty' : (left > 0 ? 'more' : 'done');
    var key = mode + ':' + (mode === 'more' ? left : 0);
    var percent = mode === 'done' ? 100 : (mode === 'empty' ? 0 : Math.max(4, Math.min(100, Math.floor(cart.total_price * 100 / min))));

    all('[data-za-ship]').forEach(function (box) {
      var text = one('[data-za-ship-txt]', box);
      var bar = one('[data-za-ship-fill]', box);

      if (bar) {
        bar.style.width = percent + '%';
      }
      if (!text || box.getAttribute('data-za-key') === key) {
        return;
      }
      box.setAttribute('data-za-key', key);
      box.setAttribute('data-state', mode);

      while (text.firstChild) {
        text.removeChild(text.firstChild);
      }
      if (mode === 'more') {
        var parts = String(T.shipMore || '').split('[suma]');
        var amount = doc.createElement('strong');
        amount.textContent = money(left);
        text.appendChild(doc.createTextNode(parts[0]));
        text.appendChild(amount);
        text.appendChild(doc.createTextNode(parts.slice(1).join('')));
      } else {
        text.appendChild(doc.createTextNode(mode === 'done' ? T.shipDone : T.shipEmpty));
      }
    });
  }

  /* ------------------------------------------------------------------
     3. Lines: "x quantity" and the pack upgrade offer
     ------------------------------------------------------------------ */

  /* The smallest larger pack that holds at least the units of this line and is cheaper than the
     same number of single units. */
  function bestPack(button, quantity) {
    var packs;
    var unit = int(button.getAttribute('data-unit'));
    var best = null;

    if (units(button.getAttribute('data-raw')) !== 1 || unit <= 0) {
      return null;
    }
    try {
      packs = JSON.parse(button.getAttribute('data-packs') || '[]');
    } catch (error) {
      return null;
    }
    toArray(packs).forEach(function (pack) {
      var count = pack ? units(pack.raw) : 0;
      var saving = unit * count - int(pack ? pack.price : 0);
      if (!pack || !pack.id || count < 2 || count < quantity || saving <= 0) {
        return;
      }
      if (!best || count < best.units) {
        best = { id: String(pack.id), name: String(pack.name || pack.raw), units: count, saving: saving };
      }
    });
    return best;
  }

  function paintLines() {
    all('.js_cat_items .js_cart_item').forEach(function (line) {
      var input = one('.qty_cart_js', line);
      var quantity = input ? Math.max(1, int(input.value)) : 1;
      var count = one('[data-za-qty]', line);
      var button = one('[data-za-nudge]', line);

      if (count && count.textContent !== String(quantity)) {
        count.textContent = String(quantity);
      }
      if (!button || button.classList.contains('is-loading')) {
        return;
      }
      var label = one('[data-za-nudge-txt]', button);
      var offer = cfg.nudge && label ? bestPack(button, quantity) : null;
      if (!offer) {
        button.hidden = true;
        button.removeAttribute('data-za-pack');
        return;
      }
      // The pack name and the amount never break in the middle ("4,00" / "lei").
      var text = fill(fill(T.nudge, 'pachet', nowrap(offer.name)), 'suma', nowrap(money(offer.saving)));
      if (label.textContent !== text) {
        label.textContent = text;
      }
      button.setAttribute('data-za-pack', offer.id);
      button.hidden = false;
    });
  }

  /* ------------------------------------------------------------------
     2. Suggestions
     ------------------------------------------------------------------ */

  function setUpsellState(box, mode) {
    if (box.getAttribute('data-state') !== mode) {
      box.setAttribute('data-state', mode);
    }
  }

  function firstAvailable(product) {
    var variants = toArray(product.variants);
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) {
        return variants[i];
      }
    }
    return null;
  }

  function imageOf(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (typeof product.featured_image === 'string' && product.featured_image) {
      return product.featured_image;
    }
    if (product.featured_image && product.featured_image.src) {
      return product.featured_image.src;
    }
    var images = toArray(product.images);
    if (typeof images[0] === 'string') {
      return images[0];
    }
    return images[0] && images[0].src ? images[0].src : '';
  }

  function buildCard(pick) {
    var product = pick.product;
    var variant = pick.variant;
    var url = typeof product.url === 'string' && product.url ? product.url : '/products/' + product.handle;
    var title = String(product.title || '');
    var src = imageOf(product, variant);
    var compare = cents(variant.compare_at_price);

    var card = doc.createElement('div');
    card.className = 'za-up';
    card.setAttribute('role', 'listitem');
    card.setAttribute('data-pid', String(product.id));

    var media = doc.createElement('a');
    media.className = 'za-up__img';
    media.href = url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (src) {
      var img = doc.createElement('img');
      img.alt = '';
      img.width = 96;
      img.height = 96;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.sizes = '96px';
      img.srcset = sized(src, 96) + ' 96w, ' + sized(src, 192) + ' 192w, ' + sized(src, 288) + ' 288w';
      img.src = sized(src, 192);
      media.appendChild(img);
    }
    card.appendChild(media);

    var name = doc.createElement('a');
    name.className = 'za-up__name';
    name.href = url;
    name.textContent = shortName(title);
    card.appendChild(name);

    var price = doc.createElement('p');
    price.className = 'za-up__price';
    if (compare > pick.price) {
      var old = doc.createElement('del');
      old.textContent = money(compare);
      price.appendChild(old);
      price.appendChild(doc.createTextNode(' '));
    }
    var current = doc.createElement('span');
    current.className = 'za-up__now';
    current.textContent = money(pick.price);
    price.appendChild(current);
    card.appendChild(price);

    var button = doc.createElement('a');
    button.className = 'za-up__btn';
    button.href = url;
    button.setAttribute('role', 'button');
    button.setAttribute('rel', 'nofollow');
    button.setAttribute('data-no-instant', '');
    button.setAttribute('data-za-add', String(variant.id));
    button.setAttribute('aria-label', T.addAria + ': ' + title);
    var label = doc.createElement('span');
    label.className = 'za-up__btn-txt';
    label.textContent = T.add;
    button.appendChild(label);
    card.appendChild(button);

    return card;
  }

  /* Best sellers printed by Liquid: every card for an empty cart, the first four not in the cart otherwise. */
  function showBest(box, inCart, limit) {
    var visible = 0;
    all('[data-za-upsell-best] .za-up', box).forEach(function (card) {
      var hide = !!inCart[card.getAttribute('data-pid')] || visible >= limit;
      var button = one('.za-up__btn', card);
      card.hidden = hide;
      if (!hide) {
        visible += 1;
      } else if (button && button.classList.contains('is-done')) {
        setButton(button, '', T.add);
      }
    });
    setUpsellState(box, visible ? 'best' : 'idle');
  }

  function renderRecs(box, products) {
    var cart = state.cart;
    var inCart = idsInCart();
    var min = int(cfg.shipMin);
    var left = min - cart.total_price;
    var picks = [];
    var list = one('[data-za-upsell-list]', box);

    toArray(products).forEach(function (product) {
      if (!product || !product.id || product.available === false || inCart[String(product.id)]) {
        return;
      }
      var variant = firstAvailable(product);
      if (variant) {
        picks.push({ product: product, variant: variant, price: cents(variant.price) });
      }
    });

    if (min > 0 && left > 0) {
      // Same order, but the products that reach the free-shipping amount come first.
      picks = picks.filter(function (pick) {
        return pick.price >= left;
      }).concat(picks.filter(function (pick) {
        return pick.price < left;
      }));
    }
    picks = picks.slice(0, MAX_CARDS);

    if (!list || !picks.length) {
      showBest(box, inCart, MAX_CARDS);
      return;
    }

    var key = picks.map(function (pick) {
      return pick.variant.id;
    }).join(',');
    if (list.getAttribute('data-za-key') !== key) {
      while (list.firstChild) {
        list.removeChild(list.firstChild);
      }
      picks.forEach(function (pick) {
        list.appendChild(buildCard(pick));
      });
      list.setAttribute('data-za-key', key);
      // A list for another product starts from its first card again.
      if (list.getAttribute('data-za-base') !== String(state.baseId)) {
        list.setAttribute('data-za-base', String(state.baseId));
        list.scrollLeft = 0;
      }
    }
    setUpsellState(box, 'recs');
  }

  function paintUpsell() {
    var box = one('[data-za-upsell]');
    var cart = state.cart;
    if (!box || !cart) {
      return;
    }
    box.setAttribute('data-za-js', '');
    if (!cfg.upsell) {
      setUpsellState(box, 'idle');
      return;
    }

    var empty = cart.item_count === 0 || state.baseId === null;
    var title = one('[data-za-upsell-title]', box);
    var heading = T.upTitle;
    if (empty) {
      heading = T.upTitleBest;
    } else if (int(cfg.shipMin) > 0 && cart.total_price < int(cfg.shipMin)) {
      heading = T.upTitleMore;
    }
    if (title && heading && title.textContent !== heading) {
      title.textContent = heading;
    }

    // The card that was just tapped keeps showing "Adăugat" for a moment.
    var wait = state.hold - now();
    if (wait > 0) {
      if (!holdTimer) {
        holdTimer = win.setTimeout(function () {
          holdTimer = null;
          paintUpsell();
        }, wait + 20);
      }
      return;
    }

    if (empty) {
      showBest(box, {}, 99);
    } else {
      var id = state.baseId;
      var known = state.recs[id];

      if (isArray(known)) {
        renderRecs(box, known);
      } else if (known === 'pending') {
        if (box.getAttribute('data-state') === 'idle') {
          setUpsellState(box, 'loading');
        }
      } else if (isPage() || drawerOpen() || state.changed) {
        // Nothing is requested for a closed drawer on a page where the cart was not touched.
        state.recs[id] = 'pending';
        if (box.getAttribute('data-state') === 'idle') {
          setUpsellState(box, 'loading');
        }
        request('GET', cfg.recsUrl + '.json?product_id=' + encodeURIComponent(id) + '&limit=' + RECS_LIMIT + '&intent=related')
          .then(function (result) {
            return result.ok && isArray(result.data.products) ? result.data.products : [];
          }, function () {
            return [];
          })
          .then(function (products) {
            state.recs[id] = products;
            paintUpsell();
          });
      }
    }
  }

  function paint() {
    var run = function () {
      paintShip();
      paintLines();
      paintUpsell();
    };
    if (state.anchor) {
      keepPlace(state.anchor, run);
    } else {
      run();
    }
  }

  /* ------------------------------------------------------------------
     Actions
     ------------------------------------------------------------------ */

  function setBusy(busy) {
    state.busy = busy;
    // Same look as the theme's own cart requests: the cart is dimmed and cannot be tapped twice.
    all('.nt_js_cart').forEach(function (form) {
      if (busy) {
        form.classList.add('ld_nt_cl');
      } else {
        form.classList.remove('ld_nt_cl');
      }
    });
  }

  function setButton(button, mode, text) {
    var label = one('.za-up__btn-txt', button);
    button.classList.remove('is-loading', 'is-done');
    if (mode) {
      button.classList.add(mode);
    }
    if (mode === 'is-loading') {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
    if (label && text) {
      label.textContent = text;
    }
  }

  /* "Adaugă" on a suggestion card. */
  function addProduct(button) {
    var variantId = int(button.getAttribute('data-za-add'));
    var card = closest(button, '.za-up');
    var box = closest(button, '[data-za-upsell]');
    var productId = card ? card.getAttribute('data-pid') : null;

    if (!variantId || state.busy) {
      return;
    }
    showUpsellError(box, '');
    showMessage('');
    setBusy(true);
    setButton(button, 'is-loading', T.adding);

    request('POST', cfg.addUrl + '.js', { items: [{ id: variantId, quantity: 1 }], sections: SECTION })
      .then(function (result) {
        if (!result.ok) {
          throw shopError(result);
        }
        if (productId) {
          state.ownAdds[productId] = true;
        }
        // First product of an empty cart: show its line. Otherwise the row of cards stays under
        // the finger while the new line is added above it.
        var wasEmpty = !state.cart || state.cart.item_count === 0;
        state.changed = true;
        state.hold = now() + 1500;
        state.anchor = wasEmpty ? null : (closest(button, '.za-upsell__row') || box);
        setButton(button, 'is-done', T.addedBtn);
        say(T.added);

        var refreshed;
        keepPlace(state.anchor, function () {
          refreshed = refreshFrom(result.data);
        });
        return refreshed.then(function () {
          reveal(variantId, wasEmpty);
          return sync();
        });
      })
      .then(function () {
        state.anchor = null;
        setBusy(false);
      }, function (error) {
        state.anchor = null;
        setBusy(false);
        setButton(button, '', T.add);
        showUpsellError(box, errorText(error));
      });
  }

  /* "Ia Set de 2 și economisești X lei": add the pack, then remove the single unit. */
  function swapPack(button) {
    var key = button.getAttribute('data-key');
    var packId = int(button.getAttribute('data-za-pack'));
    var line = closest(button, '.js_cart_item');
    var bar = line ? one('.ld_cart_bar', line) : null;

    if (!key || !packId || state.busy) {
      return;
    }
    showMessage('');
    setBusy(true);
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (bar) {
      bar.classList.add('on_star');
    }

    function release() {
      setBusy(false);
      if (doc.documentElement.contains(button)) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
      if (bar && doc.documentElement.contains(bar)) {
        bar.className = 'ld_cart_bar';
      }
    }

    request('POST', cfg.addUrl + '.js', { items: [{ id: packId, quantity: 1 }] })
      .then(function (added) {
        if (!added.ok) {
          throw shopError(added);
        }
        state.changed = true;
        return request('POST', cfg.changeUrl + '.js', { id: key, quantity: 0, sections: SECTION });
      })
      .then(function (changed) {
        if (!changed.ok) {
          // The pack is in the cart but the single unit could not be removed: show the cart as it is.
          return fetchSection().then(function () {
            return sync();
          }).then(function () {
            throw shopError(changed);
          });
        }
        return refreshFrom(changed.data).then(function () {
          say(T.swapped);
          reveal(packId, true);
          // /cart/change.js can report a stale total_price right after an add + remove (seen live:
          // 47,00 lei in the response, 37,00 lei from /cart.js a moment later), so read the cart again.
          return sync();
        });
      })
      .then(function () {
        release();
        paintLines();
      }, function (error) {
        release();
        paintLines();
        showMessage(errorText(error));
      });
  }

  function onClick(event) {
    if (!cfg || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    var add = closest(event.target, '[data-za-add]');
    if (add) {
      event.preventDefault();
      addProduct(add);
      return;
    }
    var nudge = closest(event.target, '[data-za-nudge]');
    if (nudge) {
      event.preventDefault();
      swapPack(nudge);
    }
  }

  // The "Adaugă" links act as buttons: Space works like Enter.
  function onKeydown(event) {
    if (!cfg || (event.key !== ' ' && event.key !== 'Spacebar' && event.keyCode !== 32)) {
      return;
    }
    var add = closest(event.target, '[data-za-add]');
    if (add) {
      event.preventDefault();
      addProduct(add);
    }
  }

  /* ------------------------------------------------------------------
     Watching the theme
     ------------------------------------------------------------------ */

  function watch() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers = [];

    // Lines loaded (the drawer fetches them lazily), repainted or removed by the theme: the offers
    // only need the DOM. This alone is not a cart change, so nothing is requested here.
    all('.js_cat_items').forEach(function (el) {
      var observer = new win.MutationObserver(paintLines);
      observer.observe(el, { childList: true });
      observers.push(observer);
    });

    // The total is rewritten by the theme whenever the number of items in the cart changed.
    all('.js_cat_ttprice').forEach(function (el) {
      var observer = new win.MutationObserver(scheduleSync);
      observer.observe(el, { childList: true, characterData: true, subtree: true });
      observers.push(observer);
    });

    // The drawer opens: suggestions are loaded now if they were not needed before.
    var canvas = doc.getElementById('nt_cart_canvas');
    if (canvas) {
      var wasOpen = canvas.classList.contains('act_opened');
      var opening = new win.MutationObserver(function () {
        var open = canvas.classList.contains('act_opened');
        if (open && !wasOpen) {
          paint();
        }
        wasOpen = open;
      });
      opening.observe(canvas, { attributes: true, attributeFilter: ['class'] });
      observers.push(opening);
    }
  }

  /* The theme announces its cart requests with jQuery events on <body>; its jQuery arrives late. */
  function bindThemeEvents(attempt) {
    var $ = win.jQuery_T4NT;
    if ($ && $.fn && typeof $.fn.on === 'function') {
      $(doc.body).off('.zaCart').on('CartUpdateSuccess.zaCart CartChangeSuccess.zaCart', scheduleSync);
      return;
    }
    if (attempt < 40) {
      win.setTimeout(function () {
        bindThemeEvents(attempt + 1);
      }, 500);
    }
  }

  /* Cart page: a coupon saved earlier in the drawer is filled in by the theme (assets/customerclnt.js,
     which arrives late); the closed "Am un cupon de reducere" block opens so the code can be seen. */
  function showSavedCoupon() {
    var input = doc.getElementById('couponcode');
    var block = input ? closest(input, 'details') : null;
    if (block && input.value && !block.zaShown) {
      block.zaShown = true; // once: the customer may close it again
      block.open = true;
    }
  }

  function init() {
    var next = readConfig();
    if (!next) {
      return;
    }
    cfg = next;
    T = cfg.t || {};

    if (cfg.cart && isArray(cfg.cart.items) && !state.changed) {
      state.cart = normalize(cfg.cart);
      chooseBase();
    }

    if (!listening) {
      listening = true;
      doc.addEventListener('click', onClick);
      doc.addEventListener('keydown', onKeydown);
      // Fired by the theme when the page comes back from the browser history.
      doc.addEventListener('cart:refresh', function () {
        state.changed = true;
        scheduleSync();
      });
      bindThemeEvents(0);
    }

    watch();
    if (state.cart) {
      paint();
    } else {
      sync();
    }
    if (isPage()) {
      showSavedCoupon();
      win.setTimeout(showSavedCoupon, 1500);
      win.setTimeout(showSavedCoupon, 5000);
    }
  }

  win.zaCart = { init: init };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
